var map = {
	"./template.bet575": 1717,
	"./template.bet575.tsx": 1717,
	"./template.bet777": 1718,
	"./template.bet777.tsx": 1718,
	"./template.betbetbet": 1719,
	"./template.betbetbet.tsx": 1719,
	"./template.betprofessor": 1720,
	"./template.betprofessor.tsx": 1720,
	"./template.betroyale": 1721,
	"./template.betroyale.tsx": 1721,
	"./template.betstride": 1722,
	"./template.betstride.tsx": 1722,
	"./template.buffalobet": 1983,
	"./template.buffalobet.tsx": 1983,
	"./template.chromabet": 1723,
	"./template.chromabet.tsx": 1723,
	"./template.default": 673,
	"./template.default.tsx": 673,
	"./template.epicodds": 1724,
	"./template.epicodds.tsx": 1724,
	"./template.fiestabet": 1725,
	"./template.fiestabet.tsx": 1725,
	"./template.forsport": 1726,
	"./template.forsport.tsx": 1726,
	"./template.gigabet": 1727,
	"./template.gigabet.tsx": 1727,
	"./template.goldenbet888": 1728,
	"./template.goldenbet888.tsx": 1728,
	"./template.goldenrush": 1729,
	"./template.goldenrush.tsx": 1729,
	"./template.hyperbet": 1730,
	"./template.hyperbet.tsx": 1730,
	"./template.juicybet": 1731,
	"./template.juicybet.tsx": 1731,
	"./template.junglebet": 1732,
	"./template.junglebet.tsx": 1732,
	"./template.magnumbet": 1733,
	"./template.magnumbet.tsx": 1733,
	"./template.oldgill": 1734,
	"./template.oldgill.tsx": 1734,
	"./template.puntcity": 1735,
	"./template.puntcity.tsx": 1735,
	"./template.puntgenie": 1736,
	"./template.puntgenie.tsx": 1736,
	"./template.pyramidbet": 1737,
	"./template.pyramidbet.tsx": 1737,
	"./template.questbet": 1738,
	"./template.questbet.tsx": 1738,
	"./template.slambet": 1739,
	"./template.slambet.tsx": 1739,
	"./template.sterlingparker": 1740,
	"./template.sterlingparker.tsx": 1740,
	"./template.sugarcastle": 1741,
	"./template.sugarcastle.tsx": 1741,
	"./template.templebet": 1742,
	"./template.templebet.tsx": 1742,
	"./template.titanbet": 1745,
	"./template.titanbet.tsx": 1745,
	"./template.ts": 986,
	"./template.vikingbet": 1746,
	"./template.vikingbet.tsx": 1746,
	"./template.volcanobet": 1747,
	"./template.volcanobet.tsx": 1747,
	"./template.wellbet": 1748,
	"./template.wellbet.tsx": 1748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2476;